import React, { useState } from 'react';

const languages = [
  'Service providers', 'Resources', 'Market', 'Contracts ',
  'Investments', 'communities', 'ESG', 'Enterprise', 'General',
  '-',
];
const Contact = () => {
  const [selected, setSelected] = useState(null); // <-- initially nothing selected

  return (
    <div className='bg-white'>
      <div className="px-4 sm:px-8 md:px-20 py-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-12 justify-between">
          {/* Left Section */}
          <div className="space-y-8 w-full md:w-2/3">
            <form className="space-y-6 w-full px-2 sm:px-4">
              <h1 className="text-[10px] sm:text-4xl md:text-5xl font-bold text-black">Contact Our Team</h1>

              <p className="text-[10px] md:text-[32px] leading-normal font-normal pr-2 ">
                Got any questions about our services? We are here to help. Chat with our team 24/7 for help.
              </p>


              <div className='flex md:flex-row gap-4'>
                <div className="w-full">
                  <label htmlFor="firstName" className="block text-[10px] sm:text-lg md:text-xl font-semibold text-black mb-2">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    placeholder="First Name"
                    className="w-full py-2 md:py-4 text-[10px] md:text-3xl text-black border-[#979797] shadow-md rounded-md focus:outline-none focus:ring-2 focus:ring-[#742B3E] placeholder-black"
                  />
                </div>

                <div className="w-full">
                  <label htmlFor="lastName" className="block text-[10px] sm:text-lg md:text-xl font-semibold text-black mb-2">Last  Name / Surname</label>
                  <input
                    type="text"
                    id="lastName"
                    placeholder="Bwana"
                    className="w-full py-2 md:py-4 text-[10px] md:text-3xl border-[#979797]  shadow-md rounded-md focus:outline-none focus:ring-2 focus:ring-[#742B3E] placeholder-black"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="email" className="block text-[10px] sm:text-lg md:text-xl font-semibold text-black">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="you@email.com"
                  className="w-full px-4 py-3 md:py-4 border-[#979797]  shadow-md mt-2 text-[10px] md:text-3xl rounded-md focus:outline-none focus:ring-2 focus:ring-[#742B3E] placeholder-black"
                />
              </div>

              <label htmlFor="country" className="block text-[10px] sm:text-lg md:text-xl font-semibold text-black mb-2">Phone Number</label>
              <div className="flex md:flex-row items-start md:items-center  text-white relative">
                <div className="sm:w-[130px] relative">
                  <select
                    id="country"
                    style={{
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                    }}
                    className="md:w-full  px-4 md:px-4 py-3 md:py-4 text-[10px] md:text-3xl bg-[#152C24] text-white border border-[#979797]  md:rounded-tl-md md:rounded-bl-md focus:outline-none focus:ring-2 focus:ring-green-950 appearance-none"
                  >
                    <option value="ZA">ZA</option>
                    <option value="NG">NG</option>
                    <option value="KE">KE</option>
                  </select>
                  <div className="absolute top-1/2 md:right-1 right-1 transform -translate-y-1/2 text-white pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 md:w-10 md:h-10" // 👈 Responsive sizes
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path d="M6 9l6 6 6-6" stroke="white" strokeWidth="1" />
                    </svg>
                  </div>

                </div>

                <div className="w-full">
                  <input
                    type="tel"
                    id="phone"
                    placeholder="+276475XXXXX"
                    className="w-full px-4 py-3 md:py-4 text-[10px] md:text-3xl border-[#979797]  shadow-md md:rounded-tr-md md:rounded-br-md focus:outline-none focus:ring-2 focus:ring-[#742B3E] placeholder-black"
                  />
                </div>
              </div>



            </form>
          </div>

          {/* Right Section */}
          <div className="space-y-6 w-full md:w-1/3 mt-0 md:mt-20 px-2 sm:px-0">
            <h1 className="text-[16px] md:text-4xl font-bold text-black">Chat with us</h1>
            <p className="text-[16px] md:text-[32px]  leading-normal font-normal text-black mb-5 -mt-5" style={{ lineHeight: '1.20' }}>
              Speak to our friendly team via live chat
            </p>

            <div className="flex items-center gap-3">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743940484/image_1569_qv1gio.png"
                alt="Chat Icon"
                className="w-6 h-6 sm:w-8 sm:h-8"
              />
              <p className="text-[16px]  sm:text-xl md:text-2xl font-normal text-black">Start a live chat</p>
            </div>

            <div className="flex items-center gap-3">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743943832/image_vwkadq.png"
                alt="Email Icon"
                className="w-6 h-6 sm:w-8 sm:h-8"
              />
              <p className="text-[16px] sm:text-xl md:text-2xl font-normal text-black">Send us an email</p>
            </div>

            <p className="text-[16px] sm:text-2xl md:text-3xl font-bold text-black">Message Us</p>

            <div className="grid grid-cols-1 sm:grid-cols-1 gap-4">
              {[
                { label: "Whatsapp", icon: "image-1_skfnsd.png" },
                { label: "Facebook", icon: "image_15_g4mwse.png" },
                { label: "Instagram", icon: "image_sgphk8.png" },
                { label: "Tiktok", icon: "image-4_cgzic4.png" },
                { label: "Youtube", icon: "image-1_fs5c12.png" },
                { label: "Linked In", icon: "image-2_mymqwj.png" },
                { label: "X", icon: "image-7_ytyl9r.png" }
              ].map((item, index) => (
                <a
                  key={index}
                  href="https://facebook.com"
                  className="flex items-center gap-3 text-[16px] sm:text-lg md:text-2xl hover:underline"
                >
                  <img
                    src={`https://res.cloudinary.com/dzngpgki4/image/upload/v1743863799/${item.icon}`}
                    alt={item.label}
                    className="w-6 h-6 sm:w-8 sm:h-8"
                  />
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className='md:h-0 h-6'></div>

        <div>
          <label htmlFor="message" className="block text-[10px] sm:text-lg md:text-[32px] font-semibold text-black mb-2">Message</label>
          <textarea
            id="message"
            placeholder="Send Us a Message"
            className="w-full md:px-6 md:py-6 md:mt-5 border-[2px] rounded-md focus:outline-none border-[#979797] shadow-md text-[10px] md:text-[24px] focus:ring-2 focus:ring-[#742B3E] md:h-64 h-32 placeholder-black"
          />
        </div>

        <div className="space-y-2 md:mt-12">
          <h2 className="text-[10px] sm:text-lg md:text-[32px]  font-bold text-black">Services</h2>
          <div className='md:h-1 h-1'></div>

          <h2 className="text-[10px] sm:text-lg md:text-[20px]  md:mb-5 font-normal md:mt-1 text-black">Select service</h2>
          <div className='md:h-1 h-1'></div>
          <div className="grid grid-cols-5 md:gap-2 gap-1 " >
            {languages.map((lang, i) => {
              const isActive = selected === lang;
              return (
                <button
                  key={i}
                  onClick={() => setSelected(lang)}
                  disabled={lang === '-'}
                  className={`
                flex items-center justify-between
                md:w-full md:h-[54px] h-[20px]
                bg-[#D9D9D9] text-left leading-tight
                border border-[#D9D9D9] rounded-[5px]
                md:px-5 px-2
              
              `}
                >
                  <span className="font-semibold text-[4px] md:text-[20px]">{lang}</span>
                  <span
                    className={`
                  md:w-7 md:h-7 w-3 h-3 rounded-full
                  ${isActive
                        ? 'bg-[#152C24] md:border-[5px] border-[3px] border-white'
                        : 'md:border-[5px] border-[3px] border-white bg-transparent'}
                `}
                  />
                </button>
              );
            })}
          </div>
        </div>
        <div className='md:h-28 h-8'></div>

        <button type="submit" className="bg-[#152C24] text-white md:py-7  py-3 text-xl md:text-[48px] border-b-[5px] border-[#FDBD26] font-bold w-full rounded-[10px] mt-4">
          Contact Us
        </button>
        <div className='md:h-28'></div>

      </div>
    </div>
  );
};

export default Contact;
